<div class="feedback-dialog">
  <div class="feedback-dialog__header">
    <div class="feedback-dialog__title-wrap">
      <!-- <div class="feedback-dialog__title">Send Feedback</div> -->
      <div class="feedback-dialog__subtitle">{{ helperText }}</div>
    </div>
  </div>

  <div class="feedback-dialog__type-grid">
    <button
      type="button"
      class="feedback-dialog__type-btn"
      [class.feedback-dialog__type-btn--active]="feedbackType === 'bug'"
      (click)="selectType('bug')"
      >
      <i class="ms-Icon ms-Icon--ErrorBadge" aria-hidden="true"></i>
      <span>Bug Report</span>
    </button>
    <button
      type="button"
      class="feedback-dialog__type-btn"
      [class.feedback-dialog__type-btn--active]="feedbackType === 'feature'"
      (click)="selectType('feature')"
      >
      <i class="ms-Icon ms-Icon--Lightbulb" aria-hidden="true"></i>
      <span>Feature</span>
    </button>
    <button
      type="button"
      class="feedback-dialog__type-btn"
      [class.feedback-dialog__type-btn--active]="feedbackType === 'general'"
      (click)="selectType('general')"
      >
      <i class="ms-Icon ms-Icon--Comment" aria-hidden="true"></i>
      <span>General</span>
    </button>
    <button
      type="button"
      class="feedback-dialog__type-btn"
      [class.feedback-dialog__type-btn--active]="feedbackType === 'other'"
      (click)="selectType('other')"
      >
      <i class="ms-Icon ms-Icon--Help" aria-hidden="true"></i>
      <span>Anything</span>
    </button>
  </div>

  <div class="feedback-dialog__message-head">
    <span class="feedback-dialog__section-label">Message</span>
    <span class="feedback-dialog__counter">{{ charsUsed }} / {{ maxChars }}</span>
  </div>
  <textarea
    class="feedback-dialog__textarea"
    [ngModel]="feedbackText"
    (ngModelChange)="onFeedbackTextChange($event)"
    [maxlength]="maxChars"
    placeholder="Tell us more about your experience..."
  ></textarea>

  <div class="feedback-dialog__attach-row">
    <!-- Manual file upload -->
    <label
      class="feedback-dialog__upload"
      [class.feedback-dialog__upload--active]="attachmentName"
      for="feedback-attachment-input"
      >
      <i class="ms-Icon ms-Icon--FileImage" aria-hidden="true"></i>
      <div class="feedback-dialog__upload-text">
        <div class="feedback-dialog__upload-title">{{ attachmentName || 'Attach a file' }}</div>
        <div class="feedback-dialog__upload-subtitle">{{ attachmentInfo || 'PNG, JPG up to 5 MB' }}</div>
      </div>
    </label>
    <input
      id="feedback-attachment-input"
      type="file"
      accept=".png,.jpg,.jpeg,image/png,image/jpeg"
      (change)="onAttachmentPicked($event)"
      class="feedback-dialog__upload-input"
      />

      <!-- Pre-captured screenshot attach -->
      @if (screenshotDataUrl) {
        <div
          class="feedback-dialog__screenshot-attach"
          [class.feedback-dialog__screenshot-attach--active]="screenshotAttached"
          >
          @if (screenshotAttached) {
            <img [src]="screenshotDataUrl" alt="Screenshot preview" class="feedback-dialog__screenshot-thumb" />
            <div class="feedback-dialog__screenshot-info">
              <span class="feedback-dialog__upload-title">Screenshot attached</span>
              <button type="button" class="feedback-dialog__remove-btn" (click)="removeScreenshot()">Remove</button>
            </div>
          }
          @if (!screenshotAttached) {
            <button type="button" class="feedback-dialog__screenshot-btn" (click)="attachScreenshot()">
              <i class="ms-Icon ms-Icon--Camera" aria-hidden="true"></i>
              <div class="feedback-dialog__upload-text">
                <div class="feedback-dialog__upload-title">Attach current screenshot</div>
                <div class="feedback-dialog__upload-subtitle">(optional)</div>
              </div>
            </button>
          }
        </div>
      }
    </div>

    <div class="feedback-dialog__actions">
      <button type="button" class="fs-standard-btn" (click)="close()">Cancel</button>
      <button type="button" class="fs-standard-btn feedback-dialog__submit-accent" (click)="greatFeedback()" [disabled]="!canSubmit">Submit Feedback</button>
    </div>
  </div>
